import {interpolateRoutePath} from './route-interpolation.js';
export const FLEET_STALE_MS=15*60*1000;
export function prepareFleetRoute(points){
 const ordered=points.map((point,index)=>({...point,index,time:Date.parse(point.receivedAt)}))
  .filter(p=>Number.isFinite(p.time)&&p.gpsValid===1&&Number.isFinite(p.latitude)&&Number.isFinite(p.longitude))
  .sort((a,b)=>a.time-b.time||a.id-b.id);
 const lines=[];
 for(let i=0;i<ordered.length;i++){const p=ordered[i],previous=ordered[i-1];
  p.link=Boolean(previous&&p.index===previous.index+1&&p.connectFromPrevious&&p.time>previous.time&&p.time-previous.time<=FLEET_STALE_MS);
  const coordinate={latitude:p.latitude,longitude:p.longitude};if(!p.link)lines.push([coordinate]);else lines.at(-1).push(coordinate);
 }
 return {points:ordered,times:ordered.map(p=>p.time),lines:lines.filter(line=>line.length>1),first:ordered[0]?.time??null,last:ordered.at(-1)?.time??null};
}
export function fleetPlaybackBounds(routes){
 const available=Object.values(routes).filter(r=>r.first!==null);if(!available.length)return null;
 return {start:Math.min(...available.map(r=>r.first)),end:Math.max(...available.map(r=>r.last))};
}
export function fleetFrameAt(route,time){
 let low=0,high=route.times.length;while(low<high){const mid=(low+high)>>>1;if(route.times[mid]<=time)low=mid+1;else high=mid;}
 const previous=route.points[low-1],next=route.points[low];if(!previous)return {position:null,state:'waiting',observedAt:null};
 if(time===previous.time)return {position:previous,state:'recorded',observedAt:previous.receivedAt};
 if(next?.link){const fraction=(time-previous.time)/(next.time-previous.time),motion=interpolateRoutePath([previous,next],fraction);return {position:{...previous,...motion.point},state:'interpolated',observedAt:previous.receivedAt};}
 return {position:previous,state:time-previous.time>FLEET_STALE_MS?'stale':next?'gap':'held',observedAt:previous.receivedAt};
}
export function advanceFleetClock(time,elapsed,speed,bounds){return Math.max(bounds.start,Math.min(bounds.end,time+Math.max(0,elapsed)*speed));}
